import { FIELDS } from '@/pages/ReceivePayments/components/PaymentDetails/constants';

const defaultFields = [
  {
    key: 'Id',
    field: FIELDS.ID,
    title: ' Id',
    label: 'Id',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'PaymentId',
    field: FIELDS.PAYMENT_ID,
    title: ' Payment Id',
    label: 'PaymentId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'InvoiceId',
    field: FIELDS.INVOICE_ID,
    title: ' Invoice Id',
    label: 'InvoiceId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ReferenceNumber',
    field: FIELDS.REFERENCE_NUMBER,
    title: ' Reference Number',
    label: 'ReferenceNumber',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PaymentDate',
    field: FIELDS.PAYMENT_DATE,
    title: ' Payment Date',
    label: 'PaymentDate',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PaymentMethodName',
    field: FIELDS.PAYMENT_METHOD_NAME,
    title: ' Payment Method Name',
    label: 'PaymentMethodName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Total',
    field: FIELDS.TOTAL,
    title: ' Total',
    label: 'Total',
    cell: 'formatCurrencyConverted',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Balance',
    field: FIELDS.BALANCE,
    title: ' Balance',
    label: 'Balance',
    cell: 'formatCurrencyConverted',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'PaymentAmount',
    field: FIELDS.PAYMENT_AMOUNT,
    title: ' Payment Amount',
    label: 'PaymentAmount',
    cell: 'formatAmountConverted',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CreditAmount',
    field: FIELDS.CREDIT_AMOUNT,
    title: ' Credit Amount',
    label: 'formatAmountConverted',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'Amount',
    field: FIELDS.AMOUNT,
    title: ' Amount',
    label: 'Amount',
    cell: 'formatAmountConverted',
    sortable: true,
    hidden: true,
    width: 150,
  },

  {
    key: 'Comments',
    field: FIELDS.COMMENTS,
    title: ' Comments',
    label: 'Comments',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateCreated',
    field: FIELDS.DATE_CREATED,
    title: ' Date Created',
    label: 'DateCreated',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'DateModified',
    field: FIELDS.DATE_MODIFIED,
    title: ' Date Modified',
    label: 'DateModified',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CreatedByUserId',
    field: FIELDS.CREATED_BY_USER_ID,
    title: ' Created By User Id',
    label: 'CreatedByUserId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ModifiedByUserId',
    field: FIELDS.MODIFIED_BY_USER_ID,
    title: ' Modified By User Id',
    label: 'ModifiedByUserId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CreatedByUserFullName',
    field: FIELDS.CREATED_BY_USER_FULL_NAME,
    title: ' Created By User Full Name',
    label: 'CreatedByUserFullName',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ModifiedByUserFullName',
    field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
    title: ' Modified By User Full Name',
    label: 'ModifiedByUserFullName',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'Active',
    field: FIELDS.ACTIVE,
    title: ' Active',
    label: 'Active',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
